import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import { Button } from 'antd';
import { Layout } from 'antd';
import { Menu } from 'antd'
import { Row, Col } from 'antd';

import logo from './logo.svg';
// import './App.css';
import Main from './Main';
import Main_2018 from './Main_2018'

const { Header, Footer, Sider, Content } = Layout;


const App = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <div>
      <Route path="/2018" component={Main_2018} />
      <Route path="/" component={Main} exact />
    </div>
  </Router>
);

export default App;
